/**
 * Returns true when polling brought a new last message from `senderType`
 * (skips the initial load: no chime when prevLen is 0).
 */
export function shouldChimeNewEdgeMessage(prevLen, messages, senderType) {
  if (!messages?.length || prevLen <= 0 || messages.length <= prevLen) return false;
  const last = messages[messages.length - 1];
  return last && last.senderType === senderType;
}
